import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "font-bold" }
const _hoisted_23 = { class: "font-bold text-light text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_info_field = _resolveComponent("info-field")!
  const _component_section_wrapper = _resolveComponent("section-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_spinner, {
          key: 0,
          class: "mx-auto"
        }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_section_wrapper, { class: "bg-white" }, {
            default: _withCtx(() => [
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.supplier_system_number"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.returnParcel?.supplier_system_number || "-"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.shipper_reference"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.returnParcel?.shipper_reference || "-"), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_section_wrapper, { class: "bg-white" }, {
            default: _withCtx(() => [
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.receiver"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.returnParcel?.receiver_address?.name || "-") + " ", 1),
                    _hoisted_2,
                    _createTextVNode(" " + _toDisplayString(_ctx.returnParcel?.receiver_address?.company_name || "-") + " ", 1),
                    _hoisted_3,
                    _createTextVNode(" " + _toDisplayString(_ctx.returnParcel?.receiver_address?.address_first_line || "-") + " ", 1),
                    _hoisted_4,
                    (_ctx.returnParcel?.receiver_address?.address_second_line)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.returnParcel?.receiver_address?.address_second_line || "-") + " ", 1),
                          _hoisted_5
                        ], 64))
                      : _createCommentVNode("", true),
                    _hoisted_6,
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(`${_ctx.returnParcel?.receiver_address?.city ?? ""} ${
              _ctx.returnParcel?.receiver_address?.zip ?? ""
            }`.trim() || "-") + " ", 1),
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(_ctx.returnParcel?.shipper_address?.country.name || "-") + " ", 1),
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(_ctx.returnParcel?.receiver_address?.phone || "-") + " ", 1),
                    _hoisted_10,
                    _createTextVNode(" " + _toDisplayString(_ctx.returnParcel?.receiver_address?.email || "-") + " ", 1),
                    _hoisted_11
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.shipper"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.returnParcel?.shipper_address?.name || "-") + " ", 1),
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(_ctx.returnParcel?.shipper_address?.company_name || "-") + " ", 1),
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.returnParcel?.shipper_address?.address_first_line || "-") + " ", 1),
                    _hoisted_14,
                    (_ctx.returnParcel?.shipper_address?.address_second_line)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.returnParcel?.shipper_address?.address_second_line || "-") + " ", 1),
                          _hoisted_15
                        ], 64))
                      : _createCommentVNode("", true),
                    _hoisted_16,
                    _hoisted_17,
                    _createTextVNode(" " + _toDisplayString(`${_ctx.returnParcel?.shipper_address?.city ?? ""} ${
              _ctx.returnParcel?.shipper_address?.zip ?? ""
            }`.trim() || "-") + " ", 1),
                    _hoisted_18,
                    _createTextVNode(" " + _toDisplayString(_ctx.returnParcel?.receiver_address?.country.name || "-") + " ", 1),
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(_ctx.returnParcel?.shipper_address?.phone || "-") + " ", 1),
                    _hoisted_20,
                    _createTextVNode(" " + _toDisplayString(_ctx.returnParcel?.shipper_address?.email || "-") + " ", 1),
                    _hoisted_21
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_section_wrapper, { class: "bg-white" }, {
            default: _withCtx(() => [
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.supplier"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.returnParcel?.supplier?.full_name || "-"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.product"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.returnParcel?.product?.name || "-"), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_section_wrapper, { class: "bg-white" }, {
            default: _withCtx(() => [
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.weight"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("parcels.details.weight_value", { weight: _ctx.returnParcel?.weight })), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.value"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(`${_ctx.returnParcel?.price_value ?? ""} ${
            _ctx.returnParcel?.price_currency ?? ""
          }`.trim() || "-"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_info_field, {
                class: "mb-5 md:w-1/2",
                label: "parcels.details.dimensions"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("parcels.details.dimensions_value", {
            length: _ctx.returnParcel.length,
            width: _ctx.returnParcel.width,
            height: _ctx.returnParcel.height,
          })), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.returnParcel?.products && !!_ctx.returnParcel?.products?.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_section_wrapper, { class: "bg-white" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("parcels.details.products")), 1)
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.returnParcel?.products, (product, index) => {
                  return (_openBlock(), _createBlock(_component_section_wrapper, {
                    class: "bg-white",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.product_description"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.description || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.country"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.country_name || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.sku"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.sku || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.purchase_web_address"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.purchase_web_address || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.hs_code"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.hs_code || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.item_composition"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.item_composition || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.quantity"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.quantity || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.cpc_code"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.cpc_code || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.value"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(`${product?.price_value ?? ""} ${
              product?.price_currency ?? ""
            }`.trim() || "-"), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_info_field, {
                        class: "mb-5 md:w-1/2",
                        label: "parcels.details.warehouse_number"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(product?.warehouse_number || "-"), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}